webpackJsonp([20,35],{

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = new _vue2.default();

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

	'use strict';
	
	var Format = {
	  type: {
	    required: {
	      reg: /.{1,}/,
	      msg: '此项不能为空'
	    },
	    email: {
	      reg: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
	      msg: '邮箱格式错误'
	    },
	    phone: {
	      reg: /^\d{11}$/,
	      msg: '手机格式错误'
	    },
	    float: {
	      reg: /^\d+(.\d+)?$/,
	      msg: '必须为整数或小数'
	    },
	    int: {
	      reg: /^\d+$/,
	      msg: '必须为整数'
	    }
	  },
	  do: function _do(required, format, value) {
	    var _this = this;
	    var pass = { state: true, msg: '' };
	    try {
	      if (typeof value === 'string') {
	        var value = value.replace(/\s/, '');
	      }
	    } catch (e) {
	      return {
	        state: false,
	        msg: '验证发生错误'
	      };
	    }
	
	    if (required) {
	      if (!_this.type.required.reg.test(value)) {
	        return {
	          state: false,
	          msg: _this.type.required.msg
	        };
	      }
	    }
	
	    if (typeof format === 'string') {
	      var tester = _this.type[format];
	    } else {
	      var tester = format;
	    }
	
	    if (tester == undefined) {
	      return pass;
	    }
	
	    if (tester.reg.test(value)) {
	      return pass;
	    } else {
	      if (value == '') {
	        return pass;
	      }
	      return {
	        state: false,
	        msg: tester.msg
	      };
	    }
	  }
	};
	
	module.exports = Format;

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _format = __webpack_require__(8);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _eventbus = __webpack_require__(2);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'boselect',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    value: {
	      default: ''
	    },
	    options: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    theme: {
	      type: String,
	      default: 'default' },
	    size: {
	      type: String,
	      default: 'default'
	    },
	    icon: {
	      type: String,
	      default: 'unfold'
	    },
	    state: {
	      type: String,
	      default: 'normal' },
	    enable: {
	      type: Boolean,
	      default: true
	    },
	    required: {
	      type: Boolean,
	      default: false
	    },
	    label: {
	      type: String,
	      default: ''
	    },
	    for: {
	      type: String,
	      default: ''
	    }
	  },
	  methods: {
	    getValue: function getValue() {
	      return this.valueSelf;
	    },
	    setState: function setState(state) {
	      this.stateSelf = state;
	    },
	    verify: function verify() {
	      var check = _format2.default.do(this.required, '', this.valueSelf);
	      if (check.state) {
	        this.setState('');
	      } else {
	        this.setState('wrong');
	      }
	      return check;
	    },
	    formVerify: function formVerify(formid) {
	      if (this.for === formid) {
	        _eventbus2.default.$emit('input-verify', {
	          formid: formid,
	          result: this.verify(),
	          data: {
	            name: this.name,
	            value: this.valueSelf
	          }
	        });
	      }
	    }
	  },
	  created: function created() {
	    _eventbus2.default.$on('form-verify', this.formVerify);
	  },
	  beforeDestroy: function beforeDestroy() {
	    _eventbus2.default.$off('form-verify', this.formVerify);
	  },
	
	  watch: {
	    value: function value(newval) {
	      this.valueSelf = newval;
	    }
	  },
	  data: function data() {
	    return {
	      valueSelf: this.value,
	      stateSelf: this.state
	    };
	  }
	};

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(45),
	  /* template */
	  __webpack_require__(55),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 55:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.label != '') ? _c('div', {
	    staticClass: "form-item",
	    class: [
	      'form-item-' + this.theme
	    ]
	  }, [_c('label', {
	    class: ['label-' + this.size],
	    attrs: {
	      "for": _vm.name
	    }
	  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
	    class: [
	      'be-' + _vm.stateSelf,
	      _vm.icon != '' ? 'has-icon' : ''
	    ]
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    staticClass: "select form-control",
	    class: [
	      'select-' + this.size,
	      this.theme == 'underline' ? 'select-' + this.theme : ''
	    ],
	    attrs: {
	      "name": _vm.name
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.valueSelf = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.options), function(item) {
	    return _c('option', {
	      domProps: {
	        "value": item.value
	      }
	    }, [_vm._v("\n          " + _vm._s(item.text) + "\n        ")])
	  })), _vm._v(" "), (_vm.icon != '') ? _c('i', {
	    staticClass: "icon iconfont",
	    class: ['icon-' + _vm.icon]
	  }) : _vm._e()])]) : _c('div', {
	    staticClass: "form-item",
	    class: [
	      'be-' + _vm.stateSelf,
	      _vm.icon != '' ? 'has-icon' : ''
	    ]
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    staticClass: "select form-control",
	    class: [
	      'select-' + this.size,
	      this.theme == 'underline' ? 'select-' + this.theme : ''
	    ],
	    attrs: {
	      "name": _vm.name
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.valueSelf = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.options), function(item) {
	    return _c('option', {
	      domProps: {
	        "value": item.value
	      }
	    }, [_vm._v("\n      " + _vm._s(item.text) + "\n    ")])
	  })), _vm._v(" "), (_vm.icon != '') ? _c('i', {
	    staticClass: "icon iconfont",
	    class: ['icon-' + _vm.icon]
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(108),
	  /* template */
	  __webpack_require__(221),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boSelect = __webpack_require__(49);
	
	var _boSelect2 = _interopRequireDefault(_boSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: '',
	  components: {
	    BoSelect: _boSelect2.default
	  },
	  methods: {
	    getValue: function getValue() {
	      alert(this.$refs.test.getValue());
	    },
	    setState: function setState(state) {
	      this.$refs.test.setState(state);
	    },
	    verify: function verify() {
	      alert(this.$refs.test.verify().msg);
	    }
	  },
	  data: function data() {
	    return {
	      options: [{
	        value: 1,
	        text: 'One'
	      }, {
	        value: 2,
	        text: 'Two'
	      }]
	    };
	  }
	};

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('div', {
	    staticClass: "row p0010"
	  }, [_c('div', {
	    staticClass: "p1111"
	  }, [_c('bo-select', {
	    attrs: {
	      "size": "lg",
	      "value": 2,
	      "options": _vm.options
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "p0111"
	  }, [_c('bo-select', {
	    attrs: {
	      "size": "sm",
	      "value": 1,
	      "options": _vm.options
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "p0111"
	  }, [_c('bo-select', {
	    attrs: {
	      "size": "lg",
	      "theme": "underline",
	      "value": 2,
	      "options": _vm.options
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "p0111"
	  }, [_c('bo-select', {
	    ref: "test",
	    style: ({
	      marginTop: '20px'
	    }),
	    attrs: {
	      "required": true,
	      "value": 2,
	      "options": _vm.options
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "p1000 tl"
	  }, [_c('button', {
	    staticClass: "btn btn-tiny btn-primary-blank",
	    on: {
	      "click": _vm.getValue
	    }
	  }, [_vm._v("获取输入值")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-tiny btn-primary-blank",
	    on: {
	      "click": function($event) {
	        _vm.setState('wrong')
	      }
	    }
	  }, [_vm._v("置为警告")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-tiny btn-primary-blank",
	    on: {
	      "click": function($event) {
	        _vm.setState('pass')
	      }
	    }
	  }, [_vm._v("置为通过")])])], 1)])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/20.6c1bc0d9553c43280fb3.js